import { useEffect } from 'react';
import { toolForSelection, isButtonShape, isButtonIcon, isButtonText } from './fabricHelpers';

function syncButtonText(obj) {
  if (!obj || !isButtonShape(obj) || !obj.textObj) return;
  const text = obj.textObj;
  if (obj.type === 'circle') {
    const r = (obj.radius || 60) * (obj.scaleX || 1) * 2;
    text.set({
      left: obj.left + r / 2,
      top: obj.top + r / 2,
    });
  } else {
    text.set({
      left: obj.left + (obj.width * (obj.scaleX || 1)) / 2,
      top: obj.top + (obj.height * (obj.scaleY || 1)) / 2,
    });
  }
  text.setCoords();
}

export function useFabricSelection(fabricRef, { setSelection, setActiveTool, refreshLayers }) {
  useEffect(() => {
    const fc = fabricRef.current;
    if (!fc) return undefined;

    const onSelect = (e) => {
      let obj = e.selected?.[0] || e.target || fc.getActiveObject();
      if (obj && isButtonIcon(obj) && obj.textObj) {
        obj = obj.textObj;
      }
      if (obj && isButtonText(obj) && obj.textObj) {
        fc.setActiveObject(obj.textObj);
        obj = obj.textObj;
        fc.renderAll();
      }
      setSelection(obj || null);
      const tool = toolForSelection(obj);
      if (tool) setActiveTool(tool);
      refreshLayers?.();
    };

    const onClear = () => {
      setSelection(null);
      refreshLayers?.();
    };

    const onModified = () => refreshLayers?.();

    const onMoving = (e) => {
      syncButtonText(e.target);
      fabricRef.current?.renderAll();
    };

    fc.on('selection:created', onSelect);
    fc.on('selection:updated', onSelect);
    fc.on('selection:cleared', onClear);
    fc.on('object:added', onModified);
    fc.on('object:removed', onModified);
    fc.on('object:modified', onModified);
    fc.on('object:moving', onMoving);
    fc.on('object:scaling', onMoving);

    return () => {
      fc.off('selection:created', onSelect);
      fc.off('selection:updated', onSelect);
      fc.off('selection:cleared', onClear);
      fc.off('object:added', onModified);
      fc.off('object:removed', onModified);
      fc.off('object:modified', onModified);
      fc.off('object:moving', onMoving);
      fc.off('object:scaling', onMoving);
    };
  }, [fabricRef, setSelection, setActiveTool, refreshLayers]);
}
